import type { z } from 'zod';
import { logger } from '@/shared/lib';
import { ApiError, ApiErrorCode } from './apiError';

/**
 * Проверка ответа API схемой на границе системы (writing-code.md: parse на границе).
 * Несоответствие контракту → ApiError unexpected_response (дефект контракта, пишется в лог).
 */
export function parseApiResponse<T>(schema: z.ZodType<T>, data: unknown, endpoint: string): T {
  const parsed = schema.safeParse(data);
  if (parsed.success) return parsed.data;
  logger.error('api: response does not match schema', {
    endpoint,
    issues: parsed.error.issues
      .slice(0, 5)
      .map((issue) => `${issue.path.join('.')}: ${issue.message}`),
  });
  throw new ApiError({
    code: ApiErrorCode.UnexpectedResponse,
    message: `Unexpected response from ${endpoint}`,
    status: 200,
  });
}
